export const GRID_SIZE = 34;
export const EXPECTED_PIXEL_STRING_LENGTH = GRID_SIZE * GRID_SIZE;
export const EMPTY_PIXEL_CHAR = "0";

// Index 0 is the lavender background (matches getAvatar.js identicon bg);
// indexes 1-15 are paintable colours. Order is locked: changing it would
// invalidate every previously-encoded avatar string on _User.
export const AVATAR_PALETTE = [
  "#f5f0fd",
  "#1a0a2e",
  "#ffffff",
  "#c026d3",
  "#db2777",
  "#dc2626",
  "#f97316",
  "#d97706",
  "#65a30d",
  "#059669",
  "#0891b2",
  "#48ebe2",
  "#2563eb",
  "#7c3aed",
  "#9333ea",
  "#9ca3af",
];

export const PALETTE_INDEX_TO_HEX = AVATAR_PALETTE;

export const HEX_TO_PALETTE_INDEX = AVATAR_PALETTE.reduce((acc, hex, i) => {
  acc[hex.toLowerCase()] = i;
  return acc;
}, {});
